import React from 'react';
import { Popover } from '@material-ui/core';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import CoachesCornerComments from '../Comments/CoachesCornerComments';

const SprintCardCommentsPopover = ({ item, currentUserId, onCommentAdded, className = '' }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isClosing, setIsClosing] = React.useState(false);
  const hasUnread = (item.unreadCommentCount || 0) > 0;
  const open = Boolean(anchorEl);

  const handleClose = (event, reason) => {
    // Prevent card onClick from firing when closing popover
    if (event) {
      event.stopPropagation();
      // Set a flag to prevent card onClick for a brief moment
      setIsClosing(true);
      setTimeout(() => setIsClosing(false), 100);
    }
    setAnchorEl(null);
  };

  const handleCommentAdded = () => {
    if (onCommentAdded) {
      onCommentAdded();
    }
  };

  // Expose isClosing to parent via a ref or prop if needed
  React.useEffect(() => {
    if (isClosing) {
      const timer = setTimeout(() => setIsClosing(false), 100);
      return () => clearTimeout(timer);
    }
  }, [isClosing]);

  return (
    <>
      <button
        type="button"
        className={`inline-flex items-center h-6 px-2 gap-1 text-succession-text-secondary hover:text-succession-text-primary ${className}`}
        onClick={(e) => { 
          e.stopPropagation(); 
          if (!isClosing) {
            setAnchorEl(e.currentTarget); 
          }
        }}
      >
        <ChatBubbleOutlineIcon className={hasUnread ? 'text-succession-primary' : ''} style={{ width: 14, height: 14 }} />
        <span className={`text-xs ${hasUnread ? 'font-medium text-succession-primary' : ''}`}>{item.commentCount || 0}</span>
        {hasUnread && <span className="w-1.5 h-1.5 bg-succession-primary rounded-full" />}
      </button>
      <Popover 
        open={open} 
        onClose={handleClose} 
        anchorEl={anchorEl} 
        anchorOrigin={{ vertical: 'center', horizontal: 'right' }} 
        transformOrigin={{ vertical: 'center', horizontal: 'left' }}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        PaperProps={{
          onClick: (e) => e.stopPropagation(),
          onMouseDown: (e) => e.stopPropagation(),
        }}
      >
        <div className="w-96 p-0" onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
          <CoachesCornerComments itemId={item.id} itemType="ActionPlanItem" onCommentAdded={handleCommentAdded} />
        </div>
      </Popover>
    </>
  );
};

export default SprintCardCommentsPopover;


